export const cache = {};

export const cacheOrLoad = async (id, fn) => {
    if (!cache.hasOwnProperty(id)) {
        cache[id] = await fn(id);
    }

    return cache[id];
};
